module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/The-Night-Manager.a314a39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/The-Night-Manager.jpg
// module id = /lLl
// module chunks = 0